export enum ReqExcSections {
  B1 = 'B1',
  B2 = 'B2',
}
